import { render, staticRenderFns } from "./LinkedContactListHeader.vue?vue&type=template&id=48af63d6"
import script from "./LinkedContactListHeader.vue?vue&type=script&lang=js"
export * from "./LinkedContactListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports